import { SVGProps } from 'react';

const PinScaleSmallAppearanceOutlinedCrossedFalse = (props: SVGProps<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M1.33301 14.6664L5.15854 10.8408M10.0772 9.20175V12.4808L8.98422 13.5738L2.42617 7.01573L3.51918 5.92272H6.79821L8.98423 3.73671L8.43772 2.09719L9.53073 1.00418L14.9958 6.46923L13.9028 7.56224L12.2633 7.01573L10.0772 9.20175Z"
            stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            strokeWidth={1.33333}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export default PinScaleSmallAppearanceOutlinedCrossedFalse;
